import { ClickAwayListener, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

interface ITextEditorProps {
    defaultValue: string;
    onClose: () => void;
    onSave: (value: any) => void;
}
export const TextEditor: React.FC<ITextEditorProps> = ({ defaultValue, onClose, onSave}): JSX.Element => {
    const [value, setValue] = useState<string>('');
    const handleClickAway = useCallback(() => {
        if (defaultValue !== value) {
            onSave(value);
        }
        onClose();
    }, [defaultValue, onClose, onSave, value]);
    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLDivElement>) => {
            if (event.key === 'Escape') {
                onClose();
                event.stopPropagation();
                event.preventDefault();
            } else if (event.key === 'Enter') {
                onSave(value === undefined ? 'null' : value);
                onClose();
                event.stopPropagation();
                event.preventDefault();
            }
        },
        [onClose, onSave, value],
    );
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <TextField
                value={value}
                onChange={(e) => setValue(e.target.value)}
                fullWidth
                autoFocus
                sx={{
                    height: 32,
                    padding: 0,
                }}
                inputProps={{
                    style: {
                        height: 32,
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 5
                    },
                }}
                onKeyDown={handleKeyDown}
            />
        </ClickAwayListener>
    );
};
